import {
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Button,
    Box,
    Typography,
  } from '@mui/material';
  import { useTranslation } from 'react-i18next';
  
  export const NewConversationErrorDialog = ({ open, onClose }) => {
    const { t } = useTranslation();
    
    const handleUpgradeClick = () => {
      window.open('https://billing.stripe.com/p/login/test_5kQcN481K04x7FV2nF3oA00', '_blank');
    };

    const doClose = (e) => {
      e.stopPropagation();
      onClose();
    };
    return (
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth='sm' 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            padding: '8px',
          }
        }}
      >
        <DialogTitle sx={{ 
          fontWeight: 600, 
          fontSize: 20,
          color: '#18181B',
          pt: 2,
          pb: 1
        }}>
          {t('newConversationError.errorTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ 
            color: '#71717A',
            fontSize: 16,
            mb: 1
          }}>
            {t('newConversationError.errorText')}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={handleUpgradeClick}>
                {t('settings.upgradeToPro')}
            </Button>
            <Button 
              variant="buttonStandard" 
              onClick={doClose}
              sx={{ 
                minWidth: '100px',
                fontSize: 14,
              }}
            >
              {'OK'}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    );
  };
  